import clusterItemConnector from "../cluster-item-connector"
import ClusterViewItem from "./ClusterViewItem"

export default clusterItemConnector(ClusterViewItem)
